(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rb51-promo-slider]').forEach(function (slider) {
      if (slider.dataset.rb51Ready === 'true') return;
      slider.dataset.rb51Ready = 'true';

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-rb51-promo-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-rb51-promo-dot]'));
      var previous = slider.querySelector('[data-rb51-promo-prev]');
      var next = slider.querySelector('[data-rb51-promo-next]');
      var current = 0;
      var timer = null;
      var pointerStart = null;
      var swiped = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (slides.length < 2) return;

      function show(index) {
        current = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.tabIndex = active ? 0 : -1;
        });

        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === current) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        var followingImage = slides[(current + 1) % slides.length].querySelector('img');
        if (followingImage) followingImage.loading = 'eager';
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (reducedMotion.matches || document.hidden) return;
        timer = window.setInterval(function () { show(current + 1); }, 4000);
      }

      if (previous) previous.addEventListener('click', function () { show(current - 1); start(); });
      if (next) next.addEventListener('click', function () { show(current + 1); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-rb51-promo-dot')) || 0);
          start();
        });
      });

      slider.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        pointerStart = event.clientX;
        swiped = false;
      }, { passive: true });

      slider.addEventListener('pointerup', function (event) {
        if (pointerStart === null) return;
        var distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 40) return;
        swiped = true;
        show(current + (distance < 0 ? 1 : -1));
        start();
      }, { passive: true });

      slider.addEventListener('click', function (event) {
        if (!swiped) return;
        event.preventDefault();
        swiped = false;
      }, true);

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', start);
      show(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reifenb51-shopify-products"] && !Shopify.designMode) return;
  try {
    
  const updateRb51DailyProductShelves = () => {
    const now = new Date();
    const dayKey = Math.floor(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000);
    document.querySelectorAll('[data-rb51-daily-products]').forEach((grid, gridIndex) => {
      const cards = Array.from(grid.querySelectorAll(':scope > .rb51-shopify-card'));
      const limit = Math.max(1, Number.parseInt(grid.dataset.visibleLimit, 10) || cards.length);
      if (cards.length <= limit) return;
      const start = ((dayKey * limit) + gridIndex) % cards.length;
      cards.forEach((card) => {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
      });
      for (let index = 0; index < limit; index += 1) {
        const card = cards[(start + index) % cards.length];
        card.hidden = false;
        card.removeAttribute('aria-hidden');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateRb51DailyProductShelves, { once: true });
  } else {
    updateRb51DailyProductShelves();
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.rb51-shopify-card__quantity select');
    if (!select) return;
    const card = select.closest('.rb51-shopify-card');
    const total = card?.querySelector('[data-rb51-card-total]');
    if (!total) return;
    const quantity = Math.min(4, Math.max(2, Number.parseInt(select.value, 10) || 4));
    const unitGross = Number(total.dataset.unitGross || 0) / 100;
    const unitNet = Number(total.dataset.unitNet || 0) / 100;
    const format = (value) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
    total.textContent = total.dataset.b2b === 'true'
      ? quantity + ' Reifen netto ' + format(unitNet * quantity) + ' Â· brutto ' + format(unitGross * quantity)
      : quantity + ' Reifen gesamt ' + format(unitGross * quantity);
  });

  } catch(e) { console.error(e); }
})();
})();
